'use client';
import { Div, Rating, Text } from '@pezeshk-book/ui-kit';
import React from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const CommentItem = ({ dataRow }: any) => {
  let status = '';
  let statusColor : 'primary' | 'warning' | 'tertiary' | 'danger' = 'primary';
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { dashboard: { comments } } = getDictionary(lang);
  const hrefPath = `/${lang}/${dataRow.type}/${dataRow.slug}`;

  switch (dataRow.status?.key) {
    case 'drafted':
      status = comments.status.drafted;
      statusColor = 'warning';
      break;
    case 'published':
      status = comments.status.published;
      statusColor = 'tertiary';
      break;
    case 'inactivated':
      status = comments.status.inactivated;
      statusColor = 'danger';
      break;
  }
  return (
    <Link
      prefetch={false}
      href={hrefPath}
      className={'w-full flex flex-col p-4 rounded border border-opacity-50 bg-control-50 border-control-300 gap-3'}>
      <Text typography={'sm'} color={'grey.800'} align={'right'}>
        {dataRow?.title}
      </Text>
      <Text typography={'sm'} color={'grey.500'} align={'right'}>
        {dataRow?.content}
      </Text>
      <Div className={'items-center w-full justify-between'}>
        <Text color={statusColor} typography={'xs'}>
          {status}
        </Text>
        {dataRow.type !== 'posts' ? (
          <Rating value={Number(dataRow?.score)} readOnly={true}/>
        ) : null}
      </Div>
    </Link>
  );
};
export default CommentItem;
